import { type CarrierDef } from '../common.js'
import { slcy, type slcyCredType } from './slcy.js'

export type scnnCredType = slcyCredType
export const scnn: CarrierDef<scnnCredType> = {
  ...slcy,
  scac: 'scnn',
}
